import type { ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import * as htmlToImage from 'html-to-image';
import React from 'react';
import { styles } from './pdfStyles';
import { logError } from '@zg-rentals/log-error';

export const ImageRendererWrapper = ({
  children,
  imgCallback,
}: {
  children: ReactElement;
  imgCallback: () => void;
}) => {
  React.useEffect(() => {
    imgCallback();
  }, []);

  return <>{children}</>;
};

export const renderChartToPdf = (element: ReactElement): Promise<string> =>
  new Promise((resolve, reject) => {
    const container = document.createElement('div');
    container.setAttribute('style', 'width:fit-content; z-index: -10; position: absolute; top: 0;');
    const root = createRoot(container);
    document.body.appendChild(container);

    const cleanup = () => {
      root.unmount();
      document.body.removeChild(container);
    };

    const callback = () => {
      htmlToImage
        .toPng(container)
        .then((dataUrl: string) => {
          cleanup();
          resolve(dataUrl);
          return;
        })
        .catch((e) => {
          cleanup();
          logError({ error: e, context: 'pdfImageUtils renderChartToPdf', errorType: 'HtmlToImageFailure' });
          reject(e);
        });
    };

    root.render(<ImageRendererWrapper imgCallback={callback}>{element}</ImageRendererWrapper>);
  });

export const getRowStyle = (rowNum: number, highlightRow?: boolean) => {
  let style = styles.rowOdd;
  if (highlightRow) {
    style = styles.rowHighlight;
  } else if ((rowNum + 1) % 2 === 0) {
    style = styles.rowEven;
  }
  return { ...styles.row, ...style };
};

export const sortReportByQuarter = (yearA: number, yearB: number, quarterA: string, quarterB: string) => {
  if (yearA !== yearB) {
    return yearA - yearB;
  } else {
    return quarterA.localeCompare(quarterB);
  }
};
